import { ProgressLocalStorageInterface } from "../ReportTypes";

export const ProgressFormattedCurrentSelection = (props: {
  stateData: ProgressLocalStorageInterface;
  selectedInfo: string | number;
}) => {
  const { selectedInfo, stateData } = props;
  const { scope, selectedYear } = stateData;
  return (
    <div className="flex flex-row space-x-2 py-2">
      <span className="border-r-2 pr-2">{`${selectedInfo} ${scope} Selected`}</span>
      <span>{selectedYear}</span>
    </div>
  );
};
